"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonPhoto = exports.PersonPhotoDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var image_bubble_1 = require("../elements/image-bubble");
var icon_1 = require("../elements/icon");
var use_icons_1 = require("../../hooks/use-icons");
var initials_1 = require("../../utils/initials");
var entity_link_1 = require("./entity-link");
var text_bubble_1 = require("../elements/text-bubble");
exports.PersonPhotoDefaultProps = {
  size: 80,
  link: false,
  border: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
var ImageBubbleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\n    img {\n      object-fit: cover;  \n    }\n\n    ", "\n\n    ", "\n  "], ["\n\n    img {\n      object-fit: cover;  \n    }\n\n    ", "\n\n    ", "\n  "])), function (props) {
    return props._link && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      transition: filter 0.3s;\n      &:hover {\n        filter: brightness(110%);\n      }\n    "], ["\n      transition: filter 0.3s;\n      &:hover {\n        filter: brightness(110%);\n      }\n    "])));
  }, function (props) {
    return props.border && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      border: 1px solid ", ";\n      transition: border-color 0.3s;\n      ", "\n    "], ["\n      border: 1px solid ", ";\n      transition: border-color 0.3s;\n      ", "\n    "])), theme_1.theme.COLOR('line-subtle'), function (props) {
      return props._link && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        &:hover {\n          border-color: ", ";\n        }\n      "], ["\n        &:hover {\n          border-color: ", ";\n        }\n      "])), theme_1.theme.COLOR('link'));
    });
  })
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var InitialsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n\n  "], ["\n    ", "\n\n  "])), function (props) {
    return props._link && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      &:hover {\n        border-color: ", ";\n      }\n    "], ["\n      &:hover {\n        border-color: ", ";\n      }\n    "])), theme_1.theme.COLOR('link'));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ImageBubble: (0, styled_components_1.default)(image_bubble_1.ImageBubble)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ImageBubbleStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Initials: (0, styled_components_1.default)(text_bubble_1.TextBubble)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), InitialsStyles)
};
var PersonPhoto = function (props) {
  var className = props.className,
    entity = props.entity,
    size = props.size,
    link = props.link;
  var Icons = (0, use_icons_1.useIcons)();
  var Container = link ? My.Link : My.Container;
  var containerProps = link ? {
    entity: entity
  } : {
    entity: null
  };
  var openGraph = entity.openGraph,
    photo = entity.photo;
  var image = photo || openGraph && openGraph.image;
  var bubbleInitials = entity.slug ? (0, initials_1.initials)(entity.name) : '?';
  var multiplier = bubbleInitials.length > 2 ? 0.75 : 1;
  return react_1.default.createElement(Container, __assign({}, containerProps, {
    className: className
  }), image ? react_1.default.createElement(My.ImageBubble, {
    size: size,
    image: image
  }) : react_1.default.createElement(My.Initials, {
    _link: link,
    multiplier: multiplier,
    size: size
  }, bubbleInitials));
};
exports.PersonPhoto = PersonPhoto;
exports.PersonPhoto.defaultProps = exports.PersonPhotoDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;